import zipObject from 'lodash/zipObject';

export async function promiseAllObjectValues (object) {
    return zipObject(Object.keys(object), await Promise.all(Object.values(object)));
}

// corejs 2 cannot polyfill allSettled and allSettled isn't in Node until Node12 so despite this being valid in the webspec
// tests cannot run with Promise.allSettled, so handroll it for now.
export function allSettled (promises) {
    const wrappedPromises = promises.map((promise) =>
        Promise.resolve(promise).then(
            (val) => ({ status: 'fulfilled', value: val }),
            (err) => ({ status: 'rejected', reason: err }),
        ),
    );

    return Promise.all(wrappedPromises);
}
